import { useTranslation } from "react-i18next"
import { Colors } from "../../constants/colors"
import { ShiftStatus } from "../../redux/types"
import Badge from "../Badge"

interface Props {
    shiftStatus: ShiftStatus
}

const ShiftStatusBadge = ({shiftStatus}: Props) => {
    const {t} = useTranslation(['shifts']);

    const badgeColor = () => {
      switch (shiftStatus) {
        case 'completed':
          return Colors.euro_800
        case 'planned':
          return Colors.yen_600
      }
    }

    const badgeTextColor = () => {
      switch (shiftStatus) {
        case 'completed':
          return Colors.gray4
        case 'planned':
          return Colors.gray0
      }
    }

    return (
      <Badge
        text={t(`status_${shiftStatus}`, {ns: 'shifts'})}
        backgroundColor={badgeColor()}
        textColor={badgeTextColor()}
      />
    )
}

export default ShiftStatusBadge